'use strict'
import urls from './Urls'
import axios from 'axios'

export const CHILD_API_ENDPOINTS = {
  MOBY_GET: 'moby/get',
  MOBY_ADDRESS_GET: 'moby/address/get',
  // MOBY_ENROLL_HIST_GET: 'moby/enrollHist/get',
  MOBY_SAVE: 'moby/save',
  YEARS_LIST: 'moby/years',
  ORG_SPORT_LIST: 'orgSportList',
  CONF_SPORT_SCHOOL_LIST: 'confSportSchoolList',
  CONF_SPORT_LIST: 'confSportList',
  DIVERSITY_SINGLE_SPORT: 'singleSportDiversity',
  ORG_SPORT_CREATE: 'orgSportCreate',
  ORG_SPORT_DIVERSITY_CREATE: 'orgSportDiversityCreate',
  DIVERSITY_SINGLE_SPORT_SA: 'singleSportSaDiversity',
  ACCRED_SAVE: 'accred/save',
  ADDRESS_SAVE: 'address/save',
  DIVERSITY_ORG_LIST: 'diversity/org/getList',
  DIVERSITY_ORG_SAVE: 'diversity/org/save',
  FIN_AID_LIST: 'finAid/list',
  INSERT_CONF_SPORT: 'insertConfSport',
  REMOVE_CONF_SPORT: 'removeConfSport',
  SAVE_CONF_SPORT_SCHOOL: 'saveConfSportSchool',
  DELETE_MEMBER_ORG_CONF_SPORT: 'deleteMemberOrgConfSport',
  DELETE_ALL_MEMBER_ORG_CONF_SPORT_BY_CRITERIA: 'deleteAllMemberOrgConfSportByCriteria',
  HEAD_COACH_CONTACT_CARD: 'headCoachContactCard',
  SAVE_ORG_SPORT: 'saveOrgSport',
  SAVE_ORG_SPORT_NO_VALID: 'saveOrgSportNoValid',
  DIVERSITY_SPORT_LIST: 'sportList',
  ORG_SPORT: 'orgSport',
  DELETE_ORG_SPORT: 'deleteOrgSport',
  GET_SPORT_MINS: 'sportMins',
  GET_MEMBER_ORG_BY_CONF_SPORT_SCHOOLS: 'memberOrgByConfSportSchools',
  GET_ORG_BY_CONF_SPORT_LIST: 'memberOrgByConfSports',
  REMOVE_CONF_SPORT_SCHOOL: 'removeConfSportSchool',
  PAY_MEMBERSHIP_FEE: 'payFee',
  GET_INVOICE_AND_PAYMENTS: 'invoiceAndPayments',
  GET_INVOICE_PDF: 'invoicePdf',
  IMPORT_CA_GIA: 'importCaGia',
  GET_IMPORTED_CA_GIA_DATA: 'getImportedCaGiaData',
  MOBY_FIN_AID_SAVE: 'saveMobyFinAid',
  SUBMIT_SS_FORM: 'submitSsForm',
  UPDATE_STATUS: 'updateStatus',
  PDF_SERVICE: 'pdfService',
  LOGOUT: 'logout',
  KEEP_ALIVE_PING: 'keepAlivePing',
  FIND_SS_CONTROL: 'findSsControl',
  LOAD_ORG_FORM_STATUSES: 'loadOrgFormStatuses'
}

function saveMobyEndPoint () {
  return urls.sportsSponsorshipApiController() + '/' + CHILD_API_ENDPOINTS.MOBY_SAVE
}

function saveMoaEndPoint () {
  return urls.sportsSponsorshipApiController() + '/' + CHILD_API_ENDPOINTS.ACCRED_SAVE
}

function saveAddressEndPoint () {
  return urls.sportsSponsorshipApiController() + '/' + CHILD_API_ENDPOINTS.ADDRESS_SAVE
}

function getOrgAcademicYearsEndPoint (orgId) {
  let paramStr = '?orgId=' + orgId
  return urls.memberOrgApiController() + '/' + CHILD_API_ENDPOINTS.YEARS_LIST + paramStr
}

function getMobySsEndPoint () {
  return urls.sportsSponsorshipApiController() + '/' + CHILD_API_ENDPOINTS.MOBY_GET
}

function getMobySsAddressEndPoint () {
  return urls.sportsSponsorshipApiController() + '/' + CHILD_API_ENDPOINTS.MOBY_ADDRESS_GET
}

// function getMobySsEnrollHistEndPoint () {
//   return urls.sportsSponsorshipApiController() + '/' + CHILD_API_ENDPOINTS.MOBY_ENROLL_HIST_GET
// }

function getSSOrgSportListApiEndPoint (orgId, academicYear) {
  let paramStr = '?orgId=' + orgId + '&academicYear=' + academicYear
  let dd = urls.sportsSponsorshipApiController() + '/' + CHILD_API_ENDPOINTS.ORG_SPORT_LIST + paramStr
  return dd
}

function getOrgSportDiversityApiEndPoint () {
  return urls.sportsSponsorshipApiController() + '/' + CHILD_API_ENDPOINTS.DIVERSITY_SINGLE_SPORT
}

function getOrgSportSaDiversityApiEndPoint () {
  return urls.sportsSponsorshipApiController() + '/' + CHILD_API_ENDPOINTS.DIVERSITY_SINGLE_SPORT_SA
}

function getOrgDiversityListApiEndPoint () {
  return urls.sportsSponsorshipApiController() + '/' + CHILD_API_ENDPOINTS.DIVERSITY_ORG_LIST
}

function getSaveOrgDiversityListApiEndPoint () {
  return urls.sportsSponsorshipApiController() + '/' + CHILD_API_ENDPOINTS.DIVERSITY_ORG_SAVE
}

function getConfSportListApiEndPoint (orgId, academicYear) {
  let paramStr = '?orgId=' + orgId + '&academicYear=' + academicYear
  return urls.sportsSponsorshipApiController() + '/' + CHILD_API_ENDPOINTS.CONF_SPORT_LIST + paramStr
}

function getConfSportSchoolListApiEndPoint () {
  return urls.sportsSponsorshipApiController() + '/' + CHILD_API_ENDPOINTS.CONF_SPORT_SCHOOL_LIST
}
function saveConfSportListApiEndPoint () {
  return urls.sportsSponsorshipApiController() + '/' + CHILD_API_ENDPOINTS.CONF_SPORT_LIST
}

function saveOrgDiversityList (orgDiversityList) {
  return axios.post(getSaveOrgDiversityListApiEndPoint(), orgDiversityList)
}

function loadOrgMobyYears (orgId) {
  return axios.get(getOrgAcademicYearsEndPoint(orgId))
}

function loadMobyForYr (orgId, academicYear, forPrint) {
  return axios.get(getMobySsEndPoint(), {
    params: {
      'orgId': orgId,
      'academicYear': academicYear,
      'forPrint': forPrint
    }
  })
}

function loadMobyAddress (orgId) {
  return axios.get(getMobySsAddressEndPoint(), {
    params: {
      'orgId': orgId
    }
  })
}

// function loadMobyEnrollHist (orgId, academicYear) {
//   return axios.get(getMobySsEnrollHistEndPoint(), {
//     params: {
//       'orgId': orgId,
//       'academicYear': academicYear
//     }
//   })
// }

function loadOrgSportList (orgId, academicYear) {
  return axios.get(getSSOrgSportListApiEndPoint(orgId, academicYear))
}

function loadOrgSportDiversity (orgId, sportCode, academicYear) {
  let params = {
    'orgId': orgId,
    'sportCode': sportCode,
    'academicYear': academicYear
  }
  return axios.get(getOrgSportDiversityApiEndPoint(), {'params': params})
}
function loadOrgSportSaDiversity (orgId, sportCode, academicYear) {
  let params = {
    'orgId': orgId,
    'sportCode': sportCode,
    'academicYear': academicYear
  }
  return axios.get(getOrgSportSaDiversityApiEndPoint(), {'params': params})
}

function loadOrgDiversityList (orgId, academicYear) {
  let params = {
    'orgId': orgId,
    'academicYear': academicYear
  }
  return axios.get(getOrgDiversityListApiEndPoint(), {'params': params})
}

function loadFinAidSportList (orgId, academicYear) {
  let params = {
    'orgId': orgId,
    'academicYear': academicYear
  }
  return axios.get(getFinAidListApiEndPoint(), {'params': params})
}

function loadConfSportList (orgId, academicYear) {
  return axios.get(getConfSportListApiEndPoint(orgId, academicYear))
}

function loadConfSportSchoolList (conferenceId, academicYear, sportCode) {
  let params = {
    'conferenceId': conferenceId,
    'academicYear': academicYear,
    'sportCode': sportCode
  }
  return axios.get(getConfSportSchoolListApiEndPoint(), {'params': params})
}

function saveConfSportList (confSportList) {
  return axios.post(saveConfSportListApiEndPoint(), confSportList)
}

function insertConfSportApiEndPoint () {
  return urls.sportsSponsorshipApiController() + '/' + CHILD_API_ENDPOINTS.INSERT_CONF_SPORT
}
function insertConfSport (data) {
  return axios.post(insertConfSportApiEndPoint(), data)
}

function saveMoby (data) {
  return axios.post(saveMobyEndPoint(), data)
}

function saveMoa (data) {
  return axios.post(saveMoaEndPoint(), data)
}

function saveAddress (data) {
  return axios.post(saveAddressEndPoint(), data)
}

function removeConfSport (data) {
  return axios.post(removeConfSportApiEndPoint(), data)
}
function removeConfSportApiEndPoint () {
  return urls.sportsSponsorshipApiController() + '/' + CHILD_API_ENDPOINTS.REMOVE_CONF_SPORT
}

function saveConfSportSchool (confSportSchool) {
  return axios.post(saveConfSportSchoolApiEndPoint(), confSportSchool)
}
function saveConfSportSchoolApiEndPoint () {
  return urls.sportsSponsorshipApiController() + '/' + CHILD_API_ENDPOINTS.SAVE_CONF_SPORT_SCHOOL
}

function deleteMemberOrgByConfSport (data) {
  return axios.post(deleteMemberOrgByConfSportApiEndPoint(), data)
}
function deleteMemberOrgByConfSportApiEndPoint () {
  return urls.sportsSponsorshipApiController() + '/' + CHILD_API_ENDPOINTS.DELETE_MEMBER_ORG_CONF_SPORT
}

// Head Coach Contact Card
function getHeadCoachContactCardEndPoint () {
  return urls.sportsSponsorshipApiController() + '/' + CHILD_API_ENDPOINTS.HEAD_COACH_CONTACT_CARD
}
function loadOrgSportHeadCoach (orgId, sportCode) {
  let params = {
    'orgId': orgId,
    'sportCode': sportCode
  }
  return axios.get(getHeadCoachContactCardEndPoint(), {'params': params})
}

function saveOrgSport (orgSport) {
  return axios.post(saveOrgSportApiEndPoint(), orgSport)
}
function saveOrgSportApiEndPoint () {
  return urls.sportsSponsorshipApiController() + '/' + CHILD_API_ENDPOINTS.SAVE_ORG_SPORT_NO_VALID
}

function saveOrgSportDiversityList (orgSportDiversityList) {
  return axios.post(getOrgSportDiversityListApiEndPoint(), orgSportDiversityList)
}
function getOrgSportDiversityListApiEndPoint () {
  return urls.sportsSponsorshipApiController() + '/' + CHILD_API_ENDPOINTS.DIVERSITY_SPORT_LIST
}

function getOrgSportEndPoint () {
  return urls.sportsSponsorshipApiController() + '/' + CHILD_API_ENDPOINTS.ORG_SPORT
}
function loadOrgSport (orgId, academicYear, sportCode) {
  let params = {
    'orgId': orgId,
    'academicYear': academicYear,
    'sportCode': sportCode
  }
  return axios.get(getOrgSportEndPoint(), {'params': params})
}

function getDeleteOrgSportEndPoint () {
  return urls.sportsSponsorshipApiController() + '/' + CHILD_API_ENDPOINTS.DELETE_ORG_SPORT
}
function deleteOrgSport (orgSport) {
  return axios.post(getDeleteOrgSportEndPoint(), orgSport)
}

function createOrgSport (orgSport) {
  return axios.post(getOrgSportCreateEndPoint(), orgSport)
}

function getOrgSportCreateEndPoint () {
  return urls.sportsSponsorshipApiController() + '/' + CHILD_API_ENDPOINTS.ORG_SPORT_CREATE
}

function createOrgSportDiversity (orgSport) {
  return axios.post(getOrgSportDiversityCreateEndPoint(), orgSport)
}

function getOrgSportDiversityCreateEndPoint () {
  return urls.sportsSponsorshipApiController() + '/' + CHILD_API_ENDPOINTS.ORG_SPORT_DIVERSITY_CREATE
}

function loadSportMins (academicYear, sportCode, division, subdivision) {
  return axios.get(getSportMinsSsEndPoint(), {
    params: {
      'academicYear': academicYear,
      'sportCode': sportCode,
      'division': division,
      'subdivision': subdivision
    }
  })
}

function getSportMinsSsEndPoint () {
  return urls.sportsSponsorshipApiController() + '/' + CHILD_API_ENDPOINTS.GET_SPORT_MINS
}

function loadMemberOrgByConfSportSchools (academicYear, conferenceId) {
  return axios.get(getMemberOrgByConfSportSchoolsEndPoint(), {
    params: {
      'academicYear': academicYear,
      'conferenceId': conferenceId
    }
  })
}
function getMemberOrgByConfSportSchoolsEndPoint () {
  return urls.sportsSponsorshipApiController() + '/' + CHILD_API_ENDPOINTS.GET_MEMBER_ORG_BY_CONF_SPORT_SCHOOLS
}

function getOrgByConfSportList (academicYear, orgId, conferenceId) {
  return axios.get(getOrgByConfSportListEndPoint(), {
    params: {
      'academicYear': academicYear,
      'orgId': orgId,
      'conferenceId': conferenceId
    }
  })
}
function getOrgByConfSportListEndPoint () {
  return urls.sportsSponsorshipApiController() + '/' + CHILD_API_ENDPOINTS.GET_ORG_BY_CONF_SPORT_LIST
}
// function getActiveMembers (typeId) {
//   return axios.get(getActiveMembersEndPoint(), {
//     params: {
//       'typeId': typeId
//     }
//   })
// }
// function getActiveMembersEndPoint () {
//   return urls.sportsSponsorshipApiController() + '/' + CHILD_API_ENDPOINTS.GET_ACTIVE_MEMBERS
// }

/* todo: dave..... working on this.... */
function addMemberOrgByConfSportSchool (typeId) {
  return axios.get(getAddMemberOrgByConfSportSchoolEndPoint(), {
    params: {
      'typeId': typeId
    }
  })
}
function getAddMemberOrgByConfSportSchoolEndPoint () {
  return urls.sportsSponsorshipApiController() + '/' + CHILD_API_ENDPOINTS.ADD_ORG_BY_CONF_SPORT_SCHOOL
}

function deleteAllMemberOrgByConfSportByCriteria (data) {
  return axios.post(getDeleteAllMemberOrgByConfSportByCriteriaEndPoint(), data)
}
function getDeleteAllMemberOrgByConfSportByCriteriaEndPoint () {
  return urls.sportsSponsorshipApiController() + '/' + CHILD_API_ENDPOINTS.DELETE_ALL_MEMBER_ORG_CONF_SPORT_BY_CRITERIA
}

function removeConfSportSchool (data) {
  return axios.post(removeConfSportSchoolApiEndPoint(), data)
}
function removeConfSportSchoolApiEndPoint () {
  return urls.sportsSponsorshipApiController() + '/' + CHILD_API_ENDPOINTS.REMOVE_CONF_SPORT_SCHOOL
}

function getPayMembershipFeeEndPoint () {
  return urls.sportsSponsorshipApiController() + '/' + CHILD_API_ENDPOINTS.PAY_MEMBERSHIP_FEE
}

function payMembershipFee (data) {
  return axios.post(getPayMembershipFeeEndPoint(), data)
}

function getInvoiceAndPaymentsEndPoint () {
  return urls.sportsSponsorshipApiController() + '/' + CHILD_API_ENDPOINTS.GET_INVOICE_AND_PAYMENTS
}

function getInvoicePdfEndPoint (orgId, academicYear) {
  return urls.sportsSponsorshipApiController() + '/' + CHILD_API_ENDPOINTS.GET_INVOICE_PDF + '?orgId=' + orgId + '&academicYear=' + academicYear
}

function getInvoiceAndPayments (orgId) {
  return axios.get(getInvoiceAndPaymentsEndPoint(), {
    params: {
      'orgId': orgId
    }
  })
}

function importCaGia (academicYear, orgId) {
  return axios.get(getImportCaGiaEndPoint(), {
    params: {
      'academicYear': academicYear,
      'orgId': orgId
    }
  })
}
function getImportCaGiaEndPoint () {
  return urls.sportsSponsorshipApiController() + '/' + CHILD_API_ENDPOINTS.IMPORT_CA_GIA
}

function getImportedCaGiaData (academicYear, orgId) {
  return axios.get(getImportedCaGiaDataEndPoint(), {
    params: {
      'academicYear': academicYear,
      'orgId': orgId
    }
  })
}
function getImportedCaGiaDataEndPoint () {
  return urls.sportsSponsorshipApiController() + '/' + CHILD_API_ENDPOINTS.GET_IMPORTED_CA_GIA_DATA
}

function saveFinAidList (finAidList) {
  return axios.post(getFinAidListApiEndPoint(), finAidList)
}

function getFinAidListApiEndPoint () {
  return urls.sportsSponsorshipApiController() + '/' + CHILD_API_ENDPOINTS.FIN_AID_LIST
}

function mobyFinAidSave (data) {
  return axios.post(mobyFinAidSaveEndPoint(), data)
}
function mobyFinAidSaveEndPoint () {
  return urls.sportsSponsorshipApiController() + '/' + CHILD_API_ENDPOINTS.MOBY_FIN_AID_SAVE
}

function submitReport (data) {
  return axios.post(submitReportEndPoint(), data)
}
function submitReportEndPoint () {
  return urls.sportsSponsorshipApiController() + '/' + CHILD_API_ENDPOINTS.SUBMIT_SS_FORM
}

function updateStatus (data) {
  return axios.post(updateStatusEndPoint(), data)
}
function updateStatusEndPoint () {
  return urls.sportsSponsorshipApiController() + '/' + CHILD_API_ENDPOINTS.UPDATE_STATUS
}

function pdfService (data) {
  return axios.post(pdfServiceEndPoint(), data)
}
function pdfServiceEndPoint () {
  return urls.sportsSponsorshipApiController() + '/' + CHILD_API_ENDPOINTS.PDF_SERVICE
}

function timerLogout () {
  window.location.href = '/directory/logout/cas'
}

function keepAlivePing () {
  return axios.get(keepAlivePingEndPoint())
}

function keepAlivePingEndPoint () {
  return urls.sportsSponsorshipApiController() + '/' + CHILD_API_ENDPOINTS.KEEP_ALIVE_PING
}

function findSsControl (key) {
  return axios.get(findSsControlEndPoint(), {
    params: {
      'key': key
    }
  })
}

function orgFormStatusesEndPoint () {
  return urls.sportsSponsorshipApiController() + '/' + CHILD_API_ENDPOINTS.LOAD_ORG_FORM_STATUSES
}

function loadOrgFormStatuses (academicYear) {
  return axios.get(orgFormStatusesEndPoint(), {
    params: {
      'academicYear': academicYear
    }
  })
}

function findSsControlEndPoint () {
  return urls.sportsSponsorshipApiController() + '/' + CHILD_API_ENDPOINTS.FIND_SS_CONTROL
}

export default {
  loadMobyForYr: loadMobyForYr,
  loadMobyAddress: loadMobyAddress,
  // loadMobyEnrollHist: loadMobyEnrollHist,
  loadOrgMobyYears: loadOrgMobyYears,
  saveMoby: saveMoby,
  saveMoa: saveMoa,
  saveAddress: saveAddress,
  loadOrgSportList: loadOrgSportList,
  loadOrgSportDiversity: loadOrgSportDiversity,
  loadOrgSportSaDiversity: loadOrgSportSaDiversity,
  loadOrgDiversityList: loadOrgDiversityList,
  saveOrgDiversityList: saveOrgDiversityList,
  loadFinAidSportList: loadFinAidSportList,
  loadConfSportList: loadConfSportList,
  loadConfSportSchoolList: loadConfSportSchoolList,
  saveConfSportList: saveConfSportList,
  insertConfSport: insertConfSport,
  removeConfSport: removeConfSport,
  saveConfSportSchool: saveConfSportSchool,
  deleteMemberOrgByConfSport: deleteMemberOrgByConfSport,
  deleteAllMemberOrgByConfSportByCriteria: deleteAllMemberOrgByConfSportByCriteria,
  loadOrgSportHeadCoach: loadOrgSportHeadCoach,
  saveOrgSport: saveOrgSport,
  saveOrgSportDiversityList: saveOrgSportDiversityList,
  loadOrgSport: loadOrgSport,
  deleteOrgSport: deleteOrgSport,
  createOrgSport: createOrgSport,
  createOrgSportDiversity: createOrgSportDiversity,
  loadSportMins: loadSportMins,
  loadMemberOrgByConfSportSchools: loadMemberOrgByConfSportSchools,
  getOrgByConfSportList: getOrgByConfSportList,
  // getActiveMembers: getActiveMembers,
  addMemberOrgByConfSportSchool: addMemberOrgByConfSportSchool,
  removeConfSportSchool: removeConfSportSchool,
  getPayMembershipFeeEndPoint: getPayMembershipFeeEndPoint,
  payMembershipFee: payMembershipFee,
  getInvoiceAndPaymentsEndPoint: getInvoiceAndPaymentsEndPoint,
  getInvoiceAndPayments: getInvoiceAndPayments,
  getInvoicePdfEndPoint: getInvoicePdfEndPoint,
  importCaGia: importCaGia,
  getImportedCaGiaData: getImportedCaGiaData,
  saveFinAidList: saveFinAidList,
  mobyFinAidSave: mobyFinAidSave,
  submitReport: submitReport,
  updateStatus: updateStatus,
  pdfService: pdfService,
  timerLogout: timerLogout,
  keepAlivePing: keepAlivePing,
  findSsControl: findSsControl,
  loadOrgFormStatuses: loadOrgFormStatuses
}
